"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TPASettingsProviderForModal = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var StylesContext_1 = require("../StylesContext");
var wixSDKAdapter_1 = require("../../utils/sdkAdapter/wixSDKAdapter");
var TPASettingsProviderForModal = function (_a) {
    var Wix = _a.Wix, children = _a.children, styleParamsPerBreakpointMode = _a.styleParamsPerBreakpointMode;
    var SDKAdapter = (0, wixSDKAdapter_1.createWixSDKAdapter)(Wix);
    if (!Wix) {
        return null;
    }
    return (react_1.default.createElement(StylesContext_1.StylesProvider, { SDKAdapter: SDKAdapter, styleParamsPerBreakpointMode: styleParamsPerBreakpointMode },
        react_1.default.createElement(StylesContext_1.StylesConsumer, null, function (styles) { return styles.ready && children; })));
};
exports.TPASettingsProviderForModal = TPASettingsProviderForModal;
//# sourceMappingURL=TPASettingsProviderForModal.js.map